import {Component, EventEmitter} from '@angular/core';
import {ModalComponent} from '../modal-service.service';
import {NlrSanitizeResourcePipe} from '../../../pipe/nlr-sanitize-resource-pipe';
import {NgClass} from '@angular/common';

@Component({
    selector: 'nlr-confirmation-modal',
    imports: [NlrSanitizeResourcePipe, NgClass],
    templateUrl: './confirmation-modal.component.html',
    styleUrls: ['../modal.scss', './confirmation-modal.component.scss']
})
export class ConfirmationModalComponent implements ModalComponent {
    modalClosed: EventEmitter<string> = new EventEmitter();
    modalSize: string = 'modal-md';
    title: string;
    confirmationText: string;
    yes: string;
    no: string;
    showCancel: boolean = false;
    action: string = 'yes';
    iconType: 'info' | 'warning';

    applyAndClose() {
        this.modalClosed.emit(this.action);
    }

    closeDialog(result: string) {
        this.modalClosed.emit(result);
    }
}
